import Number from "csi/heading/Number";
import declare from "dojo/_base/declare";
import UOMTypeForBOMQtyFromMaterialRendererMixin from "./UOMTypeForBOMQtyFromMaterialRendererMixin";

const UOMTypeForBOMQtyFromMaterialNumberRenderer = declare(
	[Number, UOMTypeForBOMQtyFromMaterialRendererMixin],
	{},
);

export = UOMTypeForBOMQtyFromMaterialNumberRenderer;
